

<!-- <app-test-menu></app-test-menu> -->
<app-get-company-on-start></app-get-company-on-start>
<!-- <app-voice-navigation></app-voice-navigation> -->
<app-test-menu *ngIf="(projPassToParentShowMenu || !this.desktopResolution) && showAll && !mapPage && this.translate.currentLang" (projPassToParentShowMenu)="projPassToParentShowMenuF($event)" id="topMenu" [class.stiky]="stiky"></app-test-menu>
<app-right-menu *ngIf="unika && showAll && !hideRightMenu && !mapPage && this.translate.currentLang && !isOffer"></app-right-menu>
<!-- <app-right-menu *ngIf="unika && projPassToParentShowMenu && showAll && !hideRightMenu"></app-right-menu> -->
<router-outlet></router-outlet>
<!-- <span *ngIf="this.spirikalCopyright" class="powered-by"> generated by: <a href="https://spirikal.co.il/"> spirikal </a></span> -->
<!-- <app-test-menu [class.hide-menu]="!projPassToParentShowMenu" (projPassToParentShowMenu)='projPassToParentShowMenuF($event)'></app-test-menu> -->

